import { render, staticRenderFns } from "./animals.vue?vue&type=template&id=61b0c679&scoped=true"
import script from "./animals.vue?vue&type=script&lang=js"
export * from "./animals.vue?vue&type=script&lang=js"
import style0 from "./animals.vue?vue&type=style&index=0&id=61b0c679&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b0c679",
  null
  
)

export default component.exports